import React from 'react'
import {ToolItemModal} from './tool-item-modal'
import {PrimaryButton, SecondaryButton, ButtonRow, ModalTitle} from './styled'

const SOCIAL_ADS_URL = 'https://tsabenchmarks.sandbox.thryv.com/'
const THRYV_LEADS_URL = process.env.REACT_APP_THRYV_LEADS_BENCHMARKS_URL

export function BenchmarkingToolsChoiceModal({close}) {
  const [activeUrl, setActiveUrl] = React.useState(null)
  const [activeTitle, setActiveTitle] = React.useState('')

  if (activeUrl) {
    return (
      <ToolItemModal
        open
        title={activeTitle}
        url={activeUrl}
        redirectUrl=""
        onClose={close}
      />
    )
  }

  return (
    <div style={{width: '100%'}}>
      <ModalTitle>What do you want to do?</ModalTitle>
      <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
        <ButtonRow>
          <PrimaryButton
            style={{width: '66%'}}
            onClick={() => {
              setActiveTitle('Social Ads Benchmarking Tool')
              setActiveUrl(SOCIAL_ADS_URL)
            }}
          >
            Social Ads Benchmarking Tool
          </PrimaryButton>
        </ButtonRow>
        <ButtonRow>
          <PrimaryButton
            style={{width: '66%'}}
            onClick={() => {
              setActiveTitle('Thryv Leads Benchmarking Tool')
              setActiveUrl(THRYV_LEADS_URL)
            }}
          >
            Thryv Leads Benchmarking Tool
          </PrimaryButton>
        </ButtonRow>
        <ButtonRow>
          <SecondaryButton onClick={close}>Close</SecondaryButton>
        </ButtonRow>
      </div>
    </div>
  )
}
